'use client';
import React, { useState } from 'react';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

const Pagination = ({count,setPage,page}: any) => {

  const totalPages = count;

  return (
    <ResponsivePagination
    current={page}
    total={totalPages}
    onPageChange={setPage} 
    />
  );
};

export default Pagination;
